export enum SubmissionNavbarMessageMode {
  Secure = 'Secure',
  Text = 'Text'
}
